/**
 * Quote model type
 * tag: 2403
 * @readonly
 * @enum {number} (int)
 */
export enum QuoteModelType {
  QuoteEntry = 1,
  QuoteModification = 2,
}
